import React from 'react';
import { Provider } from 'react-redux';
import ProductDetailsContainer from './ProductDetailsContainer';

export default () => (
  <Provider store={ReactOnRails.getStore('appStore')}>
    <ProductDetailsContainer />
  </Provider>
);
